const cloudinaryOptimized = (src) => {
  if (!src || typeof src !== "string" || !src.includes("res.cloudinary.com")) return src;
  if (src.includes("f_auto") || src.includes("q_auto")) return src;
  return src.replace("/upload/", "/upload/f_auto,q_auto/");
};

export const preloadImage = (url) => {
  const href = cloudinaryOptimized(url);

  if (!href || typeof document === "undefined") return;

  const existing = Array.from(document.querySelectorAll('link[rel="preload"][as="image"]')).some(
    (node) => node.getAttribute("href") === href || node.href === href
  );

  if (existing) return;

  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = href;
  link.importance = "high";

  document.head.appendChild(link);
};
